import apiServices from "../apiServices";

export const eventsApi = {
  getEvents: async (params = {}) => {
    const {
      page = 1,
      limit = 10,
      search = "",
      sortBy = "createdAt",
      sortOrder = "desc",
      type = "",
      cpdType = "",
      categoryId = "",
    } = params;

    const queryParams = new URLSearchParams();
    queryParams.append("page", page.toString());
    queryParams.append("limit", limit.toString());

    if (search) queryParams.append("search", search);
    if (type) queryParams.append("type", type);
    if (cpdType) queryParams.append("cpdType", cpdType);
    if (categoryId) queryParams.append("categoryId", categoryId);

    const response = await apiServices.get(
      `/api/v1/events/admin?${queryParams.toString()}`
    );
    return response.data;
  },
  createEvent: async (data) => {
    const response = await apiServices.post("/api/v1/events", data);
    return response.data;
  },
  updateEvent: async (id, data) => {
    const response = await apiServices.patch(`/api/v1/events/${id}`, data);
    return response.data;
  },
  deleteEvent: async (id) => {
    const response = await apiServices.delete(`/api/v1/events/${id}`);
    return response.data;
  },
  getEventById: async (id) => {
    const response = await apiServices.get(`/api/v1/events/admin/${id}`);
    return response.data;
  },
  getEventWithoutPagination: async (params = {}) => {
    const { search = "", type = "", cpdType = "", categoryId = "" } = params;

    const queryParams = new URLSearchParams();
    if (search) queryParams.append("search", search);
    if (type) queryParams.append("type", type);
    if (cpdType) queryParams.append("cpdType", cpdType);
    if (categoryId) queryParams.append("categoryId", categoryId);

    const response = await apiServices.get(
      `/api/v1/events/admin?${queryParams.toString()}`
    );
    return response.data;
  },
};
